module.exports = __webpack_public_path__ + "img/img-dashboards.800def72.svg";